// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__T_3R4","icon":"style_icon__2ZrvT","title":"style_title__25EH1","logo":"style_logo__3N858","logoContainer":"style_logoContainer__3wnlj"};